import { CallEventsEnum } from '@/types/CallEventsEnum';
import { type ICallEvent } from '@/types/ICallEvent';
import { isCallEventData } from './isCallEventData';
import { isRecord } from './isRecord';

const CALL_EVENT_KEYS: ReadonlySet<string> = new Set(
  Object.values(CallEventsEnum)
);

const isCallEventKey = (value: unknown): value is CallEventsEnum =>
  typeof value === 'string' && CALL_EVENT_KEYS.has(value);

/**
 * Type guard живого события звонка из топика `admin_calls`.
 * Опознание идёт по паре признаков: `event` из закрытого списка и
 * `status === null` (имя топика в SSE-кадре Mercure не приходит).
 *
 * Проверка `status` обязательна, а не избыточна: она делает guard
 * взаимоисключающим с `isCallHistoryEvent`, где статус, наоборот, обязан быть
 * известным значением. Без неё событие с непустым статусом подходило бы под оба
 * guard'а, и разводил бы их только порядок проверок в `parseSocketEvent`.
 *
 * @param value - произвольное значение (распарсенный JSON)
 * @returns `true`, если значение соответствует форме `ICallEvent`
 */
export const isCallEvent = (value: unknown): value is ICallEvent =>
  isRecord(value) &&
  isCallEventKey(value.event) &&
  value.status === null &&
  typeof value.datetime === 'number' &&
  isCallEventData(value.data);
